
const FORM_DEEP_CUSTOMER_EMPATHY = 'deep-customer-empathy'
const FORM_DEVELOP_EMPATHY = 'develop-your-empathy'
const FORM_INSTRUCTIONS_CUSTOMER_EMPATHY = 'instructions-customer-empathy'
const FORM_THINGS_LEARNED = 'things-learned'
const FORM_EMOTION = 'emotion'
const FORM_WRITE_CUSTOMER_PROBLEM = 'Write-customer-problem'
const FORM_CUSTOMER_PROBLEM = 'customer-problem'
const FORM_IDEAL_STATE = "ideal-state"
const FORM_BROAD_NARROW = 'Go Broad to go narrow'
const FORM_BROAD_NARROW_BRAINSTORMING = 'brainstorming-guide'
const FORM_BROAD_NARROW_GOING = 'going-narrow'
const FORM_RAPID_EXPERIMENTS = 'rapid-experiments'
const FORM_RAPID_EXPERIMENTS_TYPES_EXPERIMENTS = 'types-experiments'
const FORM_BRAINSTORMING = 'brainstorming'
const FORM_TOP_IDEAS = 'topideas'
const FORM_IDEAS_LIST = 'IdeasList'
const FORM_SKETCH = 'sketch'
const FORM_LOF_ASSUMPTIONS = 'lof-assumptions'
const FORM_HYPOTHESIS = 'hypothesis'
const FORM_DEBRIEF_EXPERIMENT = 'debrief-experiment'
const FORM_OPTION = 'option'
const FORM_INSTRUCTIONS_TEST_COME_BACK =  'instructions-test-come-back'


function getStepFromForm(formName) {
    switch (formName) {
        case FORM_DEEP_CUSTOMER_EMPATHY:
            return 2
        case FORM_DEVELOP_EMPATHY:
            return 3
        case FORM_INSTRUCTIONS_CUSTOMER_EMPATHY:
            return 4
        case FORM_THINGS_LEARNED:
            return 5
        case FORM_EMOTION:
            return 6
        case FORM_WRITE_CUSTOMER_PROBLEM:
            return 7
        case FORM_CUSTOMER_PROBLEM:
            return 8
        case FORM_IDEAL_STATE:
            return 9
        case FORM_BROAD_NARROW:
            return 10
        case FORM_BROAD_NARROW_BRAINSTORMING:
            return 11
        case FORM_BRAINSTORMING:
            return 12
        case FORM_BROAD_NARROW_GOING:
            return 13
        case FORM_TOP_IDEAS:
            return 14
        case FORM_IDEAS_LIST:
            return 15
        case FORM_SKETCH:
            return 16
        case FORM_RAPID_EXPERIMENTS:
            return 17
        case FORM_LOF_ASSUMPTIONS:
            return 18
        case FORM_RAPID_EXPERIMENTS_TYPES_EXPERIMENTS:
            return 19
        case FORM_HYPOTHESIS:
            return 20
        case FORM_INSTRUCTIONS_TEST_COME_BACK:
            return 21
        case FORM_DEBRIEF_EXPERIMENT:
            return 22
        case FORM_OPTION:
            return 23
    }
    return 0
}

function getStepForDisplay(step) {
    return (step === 19 || step === 0) ? step + 1 : step
}

export default {
    FORM_DEEP_CUSTOMER_EMPATHY,
    FORM_DEVELOP_EMPATHY,
    FORM_INSTRUCTIONS_CUSTOMER_EMPATHY,
    FORM_THINGS_LEARNED,
    FORM_EMOTION,
    FORM_WRITE_CUSTOMER_PROBLEM,
    FORM_CUSTOMER_PROBLEM,
    FORM_IDEAL_STATE,
    FORM_BROAD_NARROW,
    FORM_BROAD_NARROW_BRAINSTORMING,
    FORM_BROAD_NARROW_GOING,
    FORM_RAPID_EXPERIMENTS,
    FORM_RAPID_EXPERIMENTS_TYPES_EXPERIMENTS,
    FORM_BRAINSTORMING,
    FORM_TOP_IDEAS,
    FORM_IDEAS_LIST,
    FORM_SKETCH,
    FORM_LOF_ASSUMPTIONS,
    FORM_HYPOTHESIS,
    FORM_DEBRIEF_EXPERIMENT,
    FORM_OPTION,
    FORM_INSTRUCTIONS_TEST_COME_BACK,
    getStepFromForm,
    getStepForDisplay
}
